// extracted by mini-css-extract-plugin
export var active = "DesktopTabs-module--active--eca38";
export var fadeInAnimation = "DesktopTabs-module--fadeInAnimation--6d65b";
export var tabButton = "DesktopTabs-module--tabButton--59e46";
export var tabTitle = "DesktopTabs-module--tabTitle--a8287";
export var tabs = "DesktopTabs-module--tabs--ac289";